import React, { useState } from "react";
import { Table, Button, Tooltip, Typography, Tag, Image } from "antd";
import { EditOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import type { ColumnsType } from "antd/es/table";
import CreateLocationForm from "./addFranchise";
import EditLocationForm from "./editFranchise";
import { GET_LOCATIONS } from "./requests";
import { Location } from "../../types/location";
import { Container } from "./elements";
import AssignProducts from "./assignProducts";
import TableTitle from "./table-title";

const { Text } = Typography;

const Franchises: React.FC = () => {
  const [addingLocation, setAddingLocation] = useState(false);
  const [editingLocation, setEditingLocation] = useState<Location | null>(null);
  const [assignProductsModal, setAssignProductsModal] = useState(false);
  const [location, setLocation] = useState<Location | null>(null)
  const [nameFilter, setNameFilter] = useState<string>("");
  const [pageConfig, setPageConfig] = useState({ page: 1,
    pageSize: 10 });

  const { loading, data, refetch } = useQuery(GET_LOCATIONS, {
    variables: {
      params: pageConfig,
      name: nameFilter,
    },
  });


  const columns: ColumnsType<Location> = [
    {
      title: "",
      dataIndex: "img",
      key: "img",
      width: "8%",
      render: (img: string) => {
        if (img && img !== "") {
          return <Image width={50} src={img} />;
        } else {
          return null;
        }
      },
    },
    {
      title: "Franquicia",
      key: "name",
      render: (row: any) => (
        <div>
          <Text strong>{row?.name}</Text>
          <br />
          <Text style={{ color: "#8c8c8c" }}>
            {`${row?.address.street}, ${row?.address.city}, ${row?.address.country}`}
          </Text>
        </div>
      ),
    },

    {
      title: "Telefono",
      key: "phone",
      dataIndex: "phone",
      render: (phone) => {
        if (!phone) return <div>N/A</div>;
        return <div>{phone}</div>;
      },
    },
    {
      title: "Ordenes",
      key: "orders",
      render: () => <Tag color="green">{`0`}</Tag>,
    },
    {
      title: "Acciones",
      key: "actions",

      render: (_: any, record: Location) => (
        <div>
          <Tooltip title="Editar">
            <Button
              type="primary"
              style={{ margin: 5 }}
              icon={<EditOutlined />}
              onClick={() => setEditingLocation(record)}
            >
              Editar
            </Button>
          </Tooltip>
          <Tooltip title="Asignar Productos">
            <Button
              type="primary"
              style={{ margin: 5 }}
              icon={<UnorderedListOutlined />}
              onClick={() => {
                setAssignProductsModal(true);
                setLocation(record);
              }}
            >
              Productos
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
      </div>
      <Table
        title={() => (
          <TableTitle
            setNameFilter={setNameFilter}
            setShowCreateModal={setAddingLocation}
          />
        )}
        loading={loading}
        dataSource={data?.locations?.results || []}
        columns={columns}
        rowKey="key"
        pagination={{
          current: Number(pageConfig.page),
          defaultCurrent: pageConfig.page,
          pageSize: Number(pageConfig.pageSize),
          defaultPageSize: pageConfig.pageSize,
          total: data?.locations?.info?.count,
          showTotal: (total) => (
            <Text disabled>{`${total} resultados`}</Text>
          ),
          onChange: (page, pageSize) => {
            setPageConfig({
              page,
              pageSize,
            });
          },
          showSizeChanger: true,
        }}
      />
      <CreateLocationForm
        addingLocation={addingLocation}
        setAddingLocation={setAddingLocation}
        refetchLocations={refetch}
      />
      <EditLocationForm
        editingLocation={editingLocation}
        setEditingLocation={setEditingLocation}
        refetchLocations={refetch}
      />
      <AssignProducts
        showModal={assignProductsModal}
        setShowModal={setAssignProductsModal}
        refetch={refetch}
        location={location}
      />
    </Container>
  );
};

export default Franchises;
